import { IconProps } from "../../types/utils";

const Vegan = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.3958 8.7888C19.2774 6.86076 17.5287 4.80005 15.9774 4.80005C14.4262 4.80005 12.6774 6.86076 11.5591 8.7888C9.68066 12.0249 8.4119 16.7728 10.483 20.397C11.5476 21.9811 13.2753 22.9945 15.1774 23.1506V26.4002C15.1774 26.6861 15.3299 26.9502 15.5774 27.0931C15.8249 27.2359 16.1299 27.2359 16.3774 27.0931C16.6249 26.9502 16.7774 26.6861 16.7774 26.4002V23.1506C18.679 22.9952 20.4065 21.9831 21.4718 20.4002C23.5429 16.7731 22.2741 12.0249 20.3957 8.7888H20.3958ZM20.083 19.6002C19.3051 20.684 18.1035 21.3859 16.7774 21.5315V16.2666L19.0174 13.2801C19.1888 13.0516 19.2254 12.7487 19.1131 12.4859C19.0008 12.223 18.7569 12.0401 18.4731 12.0059C18.1894 11.9717 17.9088 12.0916 17.7374 12.3201L16.7774 13.6001V10.4001C16.7774 10.1142 16.6249 9.85015 16.3774 9.70729C16.1299 9.56444 15.8249 9.56444 15.5774 9.70729C15.3299 9.85015 15.1774 10.1143 15.1774 10.4001V16.8001L14.2174 15.5201C14.046 15.2916 13.7654 15.1717 13.4817 15.2059C13.1979 15.2401 12.954 15.423 12.8417 15.6859C12.7293 15.9487 12.766 16.2516 12.9374 16.4801L15.1774 19.4666V21.5314C13.8518 21.3866 12.6502 20.6859 11.8718 19.6033C10.1374 16.5689 11.2886 12.4427 12.9422 9.59191C14.2061 7.4144 15.4974 6.39996 15.9774 6.39996C16.4574 6.39996 17.7486 7.4144 19.0126 9.59191C20.6662 12.4423 21.8174 16.5688 20.0829 19.6001L20.083 19.6002Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Vegan;
